import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { RegistrationPageDesktop } from "./desktop";
import { RegistrationPageMobile } from "./mobile";

export const RegistrationPage = () => {
  return (
    <ResponsiveBlockSwitcher
      desktop={<RegistrationPageDesktop />}
      mobile={<RegistrationPageMobile />}
    />
  );
};
